var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    stroke: "#213867",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.969c-3.26 0-5.906 2.518-5.906 5.619 0 3.568 3.937 9.223 5.383 11.176a.646.646 0 0 0 1.046 0c1.446-1.952 5.383-7.605 5.383-11.176 0-3.101-2.645-5.62-5.906-5.62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.844a1.969 1.969 0 1 0 0-3.938 1.969 1.969 0 0 0 0 3.938"
  })));
};
export default SvgLocation;